<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      title="统计模块"
      :has-form="true"
      class="time-event-dialog-modal"
      top="15%"
      width="600px"
      @close="close"
      @confirm="handleConfirm"
      append-to-body
    >
      <gs-form
        :model="form"
        label-width="60px"
        label-position="left"
        gap="small"
      >
        <gs-form-item label="名称" prop="name" class="form-item-radio">
          <gs-input ref="nameInput" v-model="name" />
        </gs-form-item>

        <gs-form-item label="描述" prop="description" class="form-item-radio">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="description"
          >
          </el-input>
        </gs-form-item>

        <gs-form-item label="标签" prop="target" class="form-item-radio">
          <div style="display: flex; align-items: center; gap: 10px">
            <gs-input v-model="label" readonly placeholder="请选择标签" />
            <gs-button @click="openLabelManage" size="small" type="primary"
              >...</gs-button
            >
          </div>
        </gs-form-item>
        <gs-form-item label="统计类型" class="form-item-radio">
          <gs-select
            style="width: 150px"
            v-model="form.type"
            placeholder="请选择统计类型"
          >
            <gs-option label="在线数量" value="online" />
            <gs-option label="计数" value="count" />
            <gs-option label="计算" value="compute" />
          </gs-select>
        </gs-form-item>

        <gs-form-item label="时间间隔" class="form-item-radio">
          <gs-select
            style="width: 150px"
            v-model="selectedCronType"
            placeholder="请选择时间间隔"
            @change="handleCronTypeChange"
          >
            <gs-option
              v-for="option in cronOptions"
              :key="option.type"
              :label="option.label"
              :value="option.type"
            ></gs-option>
          </gs-select>
        </gs-form-item>

        <div
          v-if="form.type === 'count'"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;
          "
        >
          <gs-form-item label="统计内容" class="form-item-radio">
            <gs-select
              v-model="statisType"
              style="width: 150px"
              @change="clearAttribute"
            >
              <gs-option label="总数" value="total" />
              <gs-option label="等于某个值" value="equal" />
              <gs-option label="在某个范围内" value="range" />
            </gs-select>
          </gs-form-item>

          <gs-input
            v-if="statisType === 'equal'"
            v-model="attribute.min"
            placeholder="请输入"
          />

          <gs-form-item
            v-if="statisType === 'range'"
            label="最小值"
            class="form-item-radio"
            label-width="45px"
          >
            <gs-input v-model="attribute.min" placeholder="请输入" />
          </gs-form-item>
          <gs-form-item
            v-if="statisType === 'range'"
            label="最大值"
            label-width="45px"
            class="form-item-radio"
          >
            <gs-input v-model="attribute.max" placeholder="请输入" />
          </gs-form-item>
        </div>

        <gs-form-item
          v-if="form.type === 'compute'"
          label="计算方法"
          style="width: 150px"
          class="form-item-radio"
        >
          <gs-select
            v-model="form.method"
            placeholder="请选择计算方法"
            style="width: 150px"
          >
            <gs-option label="求和" value="sum" />
            <gs-option label="平均值" value="average" />
            <gs-option label="最大值" value="max" />
            <gs-option label="最小值" value="min" />
            <gs-option label="中位数" value="median" />
          </gs-select>
        </gs-form-item>

        <gs-form-item label="接收点位" prop="target" class="form-item-radio">
          <div style="display: flex; align-items: center; gap: 10px">
            <gs-input v-model="resultName" readonly />
            <gs-button @click="getDataList">...</gs-button>
          </div>
        </gs-form-item>
      </gs-form>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm"
          >确 定</gs-button
        >
        <gs-button type="primary" size="mini" @click="beforeClose"
          >取 消</gs-button
        >
      </span>
    </gs-modal>
    <gs-modal
      v-model="visibleAdd"
      :before-close="beforeCloseAdd"
      class="my-test-class"
      title="添加"
      @close="closeAdd"
      @confirm="handleConfirmAdd"
    >
      <div style="width: 100%; height: 500px">
        <gs-tree
          v-if="visibleAdd"
          ref="tree"
          :data="addList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>

    <!-- 标签管理组件 -->
    <label-manage @confirm="handleConfirmLabel" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";
import LabelManage from "./labelManage.vue";
import EventBus from "@/components/eventBus.js";
export default {
  components: {
    LabelManage,
  },
  data() {
    return {
      props: {
        label: "name",
        disabled: "type:folder",
      },
      visibleAdd: false,
      loading: false,
      name: "",
      unit: "",
      description: "",
      form: {
        objectSeries: [],
      },
      isEdit: false,
      addList: [],
      objectSeries: [],
      resultId: "",
      resultName: "",
      label: "",
      statisType: "total",
      attribute: {
        min: "",
        max: "",
      },
      labelId: "",
      seconds: 0,
      randomInt: 1,
      // cron表达式选项
      cronOptions: [
        { label: "每1分钟", pattern: "* * * * * ?", type: "minute" },
        { label: "每5分钟", pattern: "*/5 * * * ?", type: "5minute" },
        { label: "每1小时", pattern: "0 * * * ?", type: "hour" },
        { label: "每1天", pattern: "0 0 * * ?", type: "day" },
      ],
      selectedCronType: "", // 当前选中的cron类型
    };
  },
  computed: {
    ...mapState({
      visible: "statisticsModuleShow",
      nodeData: "nodeTree",
      objectData: "objectInfo",
    }),
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData;
    },
    visible() {
      if (this.visible) {
        this.attribute = {
          min: "",
          max: "",
        };
        this.resultName = "";
        this.resultId = "";
        this.label = "";
        this.labelId = "";
        this.name = "";
        this.description = "";
        this.objectSeries = [];
        setTimeout(() => {
          this.$refs.nameInput.focus();
        }, 100);
        console.log(this.objectData);
        if (
          this.objectData &&
          JSON.stringify(this.objectData) !== "{}" &&
          this.objectData.type === "labelStatistics"
        ) {
          service.getNode(this.objectData.id).then((res) => {
            this.form = res;
            this.form.type = res.attribute.type;
            this.form.cron = res.attribute.cron;
            this.form.method = res.attribute.method;
            this.attribute = res.attribute;
            this.description = res.description;
            this.name = res.name;
            this.unit = res.attribute.unit;
            this.resultId = res.attribute.resultId;
            this.resultName = res.attribute.resultName;
            this.labelId = res.attribute.labelId;
            this.label = res.attribute.labelName;

            // 解析cron表达式并设置回显
            this.selectedCronType = this.parseCronExpression(
              res.attribute.cron
            );

            if (res.attribute.min && !res.attribute.max) {
              this.statisType = "equal";
              this.attribute.min = res.attribute.min;
              this.attribute.max = "";
            } else if (res.attribute.min && res.attribute.max) {
              this.statisType = "range";
              this.attribute.min = res.attribute.min;
              this.attribute.max = res.attribute.max;
            } else {
              this.statisType = "total";
              this.attribute.min = "";
              this.attribute.max = "";
            }
          });
          this.isEdit = true;
        } else {
          this.isEdit = false;

          this.form = {};
          this.attribute = {
            min: "",
            max: "",
          };
          this.resultName = "";
          this.resultId = "";
          this.label = "";
          this.labelId = "";
          this.description = "";
          this.name = "";
          this.objectSeries = [];
        }
      } else {
        this.isEdit = true;
        this.form = {};
        this.description = "";
        this.name = "";
        this.objectSeries = [];
        this.selectedCronType = "";
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations({
      close: "STATISTICS_MODULE_HIDE",
      openLabelManage: "LABEL_MANAGE_SHOW",
    }),
    //主
    beforeClose() {
      this.close();
    },

    // 处理cron类型变化
    handleCronTypeChange(cronType) {
      this.generateCronExpression(cronType);
    },

    // 生成cron表达式
    generateCronExpression(cronType) {
      this.seconds = new Date().getSeconds();
      this.randomInt = Math.floor(Math.random() * 4) + 1;

      switch (cronType) {
        case "minute":
          this.form.cron = `${this.seconds} * * * * ?`;
          break;
        case "5minute":
          this.form.cron = `${this.seconds} ${this.randomInt}/5 * * * ?`;
          break;
        case "hour":
          this.form.cron = `${this.seconds} 0 * * * ?`;
          break;
        case "day":
          this.form.cron = `${this.seconds} 0 0 * * ?`;
          break;
        default:
          this.form.cron = "";
      }
    },

    // 解析cron表达式，用于回显
    parseCronExpression(cronExpression) {
      if (!cronExpression) return "";

      const parts = cronExpression.split(" ");
      if (parts.length !== 6) return "";

      const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] = parts;

      // 每1分钟: "秒 * * * * ?"
      if (
        minutes === "*" &&
        hours === "*" &&
        dayOfMonth === "*" &&
        month === "*" &&
        dayOfWeek === "?"
      ) {
        return "minute";
      }

      // 每5分钟: "秒 数字/5 * * * ?"
      if (
        minutes.includes("/5") &&
        hours === "*" &&
        dayOfMonth === "*" &&
        month === "*" &&
        dayOfWeek === "?"
      ) {
        return "5minute";
      }

      // 每1小时: "秒 0 * * * ?"
      if (
        minutes === "0" &&
        hours === "*" &&
        dayOfMonth === "*" &&
        month === "*" &&
        dayOfWeek === "?"
      ) {
        return "hour";
      }

      // 每1天: "秒 0 0 * * ?"
      if (
        minutes === "0" &&
        hours === "0" &&
        dayOfMonth === "*" &&
        month === "*" &&
        dayOfWeek === "?"
      ) {
        return "day";
      }

      return "";
    },
    handleConfirm() {
      if (!this.name) {
        return this.$message.warning("请输入名称！");
      }
      if (!this.description) {
        return this.$message.warning("请输入描述！");
      }
      if (this.statisType === "equal") {
        if (this.attribute.min === "") {
          return this.$message.warning("请输入等于值！");
        }
      } else if (this.statisType === "range") {
        if (!this.attribute.min || !this.attribute.max) {
          return this.$message.warning("最小值和、最大值不能为空！");
        }
      }

      if (!this.labelId) {
        return this.$message.warning("请选择标签！");
      }
      if (!this.form.type) {
        return this.$message.warning("请选择统计类型！");
      }
      if (!this.selectedCronType || !this.form.cron) {
        return this.$message.warning("请选择时间间隔！");
      }
      if (!this.resultId) {
        return this.$message.warning("请选择接收点位！");
      }
      this.seconds = new Date().getSeconds();
      this.randomInt = Math.floor(Math.random() * 4) + 1;
      let obj = {
        name: this.name,
        description: this.description,
        type: "labelStatistics",
        parentId: this.nodeData.id,

        attribute: {
          jobName: 8,
          jobGroupName: this.nodeData.name,
          labelId: this.labelId,
          labelName: this.label,
          type: this.form.type,
          cron: this.form.cron,
          method: this.form.method,
          min: this.attribute.min,
          max: this.attribute.max,
          resultId: this.resultId,
          resultName: this.resultName,
        },
      };
      console.log(this.isEdit);
      if (this.isEdit) {
        obj.id = this.objectData.id;
        service
          .editPoint(obj)
          .then((res) => {
            this.$message.success("修改成功");
            this.close();
            EventBus.$emit("refresh");
          })
          .catch((err) => {
            this.$message.error("创建失败");
          });
      } else {
        service
          .newAddPoint(obj)
          .then((res) => {
            this.$message.success("创建成功");
            this.close();
            EventBus.$emit("refresh");
          })
          .catch((err) => {
            this.$message.error("创建失败");
          });
      }
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      done();
    },
    // add() {
    //   let _this = this;
    //   let id = "";
    //   if (_this.nodeData.type === "device") {
    //     id = _this.nodeData.id;
    //   } else {
    //     id = _this.nodeData.parentId;
    //   }
    //   this.visibleAdd = true;
    //   if (this.nodeData.type == "logicalGroup") {
    //     service.getTree("", this.nodeData.id).then((res) => {
    //       res[0].children.forEach((item) => {
    //         service.getTree("Point", item.id).then((restree) => {
    //           item.children = restree[0].children;
    //         });
    //       });
    //       setTimeout(() => {
    //         _this.addList = res;
    //       }, 2000);
    //     });
    //   } else if (
    //     this.nodeData.type == "server" ||
    //     this.nodeData.type == "project"
    //   ) {
    //     service.getAllTree().then((res) => {
    //       _this.addList = res;
    //     });
    //   } else if (this.nodeData.type == "deviceGroup") {
    //     service.getTree("EnergyCalculation", this.nodeData.id).then((res) => {
    //       _this.addList = res;
    //       if (_this.objectSeries !== null && _this.objectSeries.length > 0) {
    //         setTimeout(() => {
    //           _this.objectSeries.forEach((res) => {
    //             _this.$refs.tree.setChecked(res.id, true);
    //           });
    //         }, 0);
    //       }
    //     });
    //     /* service.getChildrenNode(this.nodeData.id).then(res => {
    //       // _this.addList = res;
    //       res[0].children.forEach(item => {
    //         service.getTree('Point', item.id).then(restree => {
    //           item.children = restree[0].children
    //         })
    //       })
    //       setTimeout(() => {
    //         _this.addList = res;
    //       }, 2000)
    //     }) */
    //   } else {
    //     service.getTree("EnergyCalculation", id).then((res) => {
    //       _this.addList = res;
    //       if (_this.objectSeries !== null && _this.objectSeries.length > 0) {
    //         setTimeout(() => {
    //           _this.objectSeries.forEach((res) => {
    //             _this.$refs.tree.setChecked(res.id, true);
    //           });
    //         }, 0);
    //       }
    //     });
    //   }
    // },
    delObjectSeriesArray(val) {
      this.objectSeries.forEach((value, index, array) => {
        if (val.name === value.name) {
          this.objectSeries.splice(index, 1);
        }
      });
    },
    beforeCloseAdd() {
      this.visibleAdd = false;
    },
    checkEvent(node, isSelect, halfSelect) {
      /* console.log(node)
      console.log(isSelect)
      console.log(halfSelect) */
      // value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      switch (node.type) {
        case "value_Analog":
          this.singleChoice(node.id);
          break;
        case "value_Multistate":
          this.singleChoice(node.id);
          break;
        case "value_Binary":
          this.singleChoice(node.id);
          break;
        case "value_String":
          this.singleChoice(node.id);
          break;
        case "BinaryInput":
          this.singleChoice(node.id);
          break;
        case "BinaryOutput":
          this.singleChoice(node.id);
          break;
        case "AnalogInput":
          this.singleChoice(node.id);
          break;
        case "AnalogOutput":
          this.singleChoice(node.id);
          break;
        case "boolWrite":
          this.singleChoice(node.id);
          break;

        case "BinaryInputW":
          this.singleChoice(node.id);
          break;
        case "BinaryInputR":
          this.singleChoice(node.id);
          break;
        case "BinaryOutputW":
          this.singleChoice(node.id);
          break;
        case "BinaryOutputR":
          this.singleChoice(node.id);
          break;
        case "AnalogInputW":
          this.singleChoice(node.id);
          break;
        case "AnalogInputR":
          this.singleChoice(node.id);
          break;
        case "AnalogOutputW":
          this.singleChoice(node.id);
          break;
        case "AnalogOutputR":
          this.singleChoice(node.id);
          break;
        case "DigitalOutputW":
          this.singleChoice(node.id);
          break;
        case "DigitalOutputR":
          this.singleChoice(node.id);
          break;
        case "DigitalInputW":
          this.singleChoice(node.id);
          break;
        case "DigitalInputR":
          this.singleChoice(node.id);
          break;
        case "AnalogW":
          this.singleChoice(node.id);
          break;
        case "IntegerW":
          this.singleChoice(node.id);
          break;
        case "AnalogR":
          this.singleChoice(node.id);
          break;
        case "IntegerR":
          this.singleChoice(node.id);
          break;
        case "BinaryW":
          this.singleChoice(node.id);
          break;
        case "BinaryR":
          this.singleChoice(node.id);
          break;
        default:
          this.$Message.error("此节点为目录，无法被选择");
          this.$refs.tree.setChecked(node.id, false);
          break;
      }
    },

    // 单选操作
    singleChoice(id) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys();
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach((item) => {
          if (item != id) {
            this.$refs.tree.setChecked(item, false);
          }
        });
      }
    },
    handleConfirmAdd() {
      this.$refs.tree.getCheckedNodes(true).forEach((e) => {
        this.objectSeries.push(e.data);
      });
      this.objectSeries = this.unique(this.objectSeries, "id");
      console.log(this.objectSeries);
      if (this.objectSeries.length > 0) {
        this.resultId = this.objectSeries[0].id;
        this.resultName = this.objectSeries[0].fullName;
      }
      this.visibleAdd = false;
    },
    unique(arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    closeAdd() {
      this.visibleAdd = false;
    },

    getDataList() {
      let _this = this;
      _this.addList = [];
      this.visibleAdd = true;
      if (this.nodeData.type == "server" || this.nodeData.type == "project") {
        setTimeout(() => {
          service.getAllTree().then((res) => {
            _this.addList = res;
          });
        }, 1000);
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree("", this.nodeData.id).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          setTimeout(() => {
            _this.addList = res;
          }, 3000);
        });
      } else {
        service.getTree("Point", this.nodeData.id).then((res) => {
          if (res[0] !== null) {
            this.addList = res;
          }
          this.addList = res;
        });
      }
    },
    handleConfirmLabel(label) {
      if (label) {
        console.log(label);
        this.label = label[0].name;
        this.labelId = label[0].id;
      }
    },
    clearAttribute() {
      this.attribute.max = "";
      this.attribute.min = "";
    },
  },
};
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.addTree {
  cursor: pointer;
  color: rgb(248, 121, 1);
}

.inp >>> .gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries >>> .gs-form-item {
  margin-bottom: 0px m !important;
}
</style>



// WEBPACK FOOTER //
// src/components/statisticModule/Index.vue